import component, { icon } from './overview/ReorderPointOverview';

export const reorderPoint = {
    title: 'reorderPoint.title',
    path: '/reorderPoint',
    icon,
    component
};
